import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IReceiptServices } from 'libs/core/src/lib/services/shared-receipt.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import {
  createQueryParams,
  IPaginatedResponse,
  IReceipt,
  IReceiptQueryParams,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentReceiptsService implements IReceiptServices {
  private representativeService = inject(RepresentativeService);

  constructor(private http: HttpClient) {}

  getReceipts(
    param?: Partial<IReceiptQueryParams>,
  ): Observable<IPaginatedResponse<IReceipt>> {
    param = {
      intermediaryId:
        this.representativeService.getLoggedInAgentRepresentative().agentId,
    };
    return this.http.get<IPaginatedResponse<IReceipt>>(
      `${baseUrl()}/allocations/receipts`,
      { params: createQueryParams(param) },
    );
  }
}
